import React from "react";
import { Quote } from "lucide-react";
import { testimonials } from "../mock";

export default function Testimonials() {
  return (
    <section className="py-28 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-14">
          <div className="text-xs tracking-[0.32em] text-emerald-400 uppercase mb-4">06 — Signal</div>
          <h2 className="gt-serif text-4xl md:text-5xl max-w-3xl">
            The receipts. From operators who close, not talkers who post.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="gt-hairline gt-hover-lift rounded-2xl p-7 bg-gradient-to-br from-white/[0.03] to-transparent flex flex-col"
            >
              <Quote className="w-6 h-6 text-emerald-400" />
              <blockquote className="mt-5 text-neutral-200 leading-relaxed flex-1">“{t.quote}”</blockquote>
              <figcaption className="mt-6 pt-6 border-t border-white/5">
                <div className="text-white text-sm">{t.name}</div>
                <div className="text-xs text-neutral-500">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
